export class AuditModel{
    firstName:string;
}
